const sectionTemplates = [
  {
    name: "Standard",
    arrangement: ["v", "c", "v", "c", "b", "c"],
  },
  {
    name: "Extended",
    arrangement: ["v", "c", "v", "c", "v", "b", "c"],
  },
  {
    name: "Simple",
    arrangement: ["v", "c", "v", "c"],
  },
  {
    name: "Bridge First",
    arrangement: ["b", "v", "c", "v", "c"],
  },
  {
    name: "Outro Heavy",
    arrangement: ["v", "c", "v", "c", "c", "c"],
  },
  {
    name: "Intro and Outro",
    arrangement: ["v", "c", "b", "c", "v", "c"],
  },
  {
    name: "Double Bridge",
    arrangement: ["v", "c", "v", "b", "b", "c"],
  },
  {
    name: "Refrain Heavy",
    arrangement: ["v", "c", "v", "c", "c"],
  },
  {
    name: "Minimalist",
    arrangement: ["v", "c"],
  },
  {
    name: "All Verse",
    arrangement: ["v", "v", "v", "v"],
  },
  {
    name: "Verse Driven",
    arrangement: ["v", "v", "c", "v", "c"],
  },
  {
    name: "Double Verse",
    arrangement: ["v", "v", "c", "v", "v", "c"],
  },
  {
    name: "No Bridge",
    arrangement: ["v", "c", "v", "c", "v", "c"],
  },
  {
    name: "Climactic",
    arrangement: ["v", "c", "v", "b", "c", "b", "c"],
  },
  {
    name: "Retro",
    arrangement: ["v", "b", "v", "c", "b", "c"],
  },
  {
    name: "Experimental",
    arrangement: ["b", "c", "v", "b", "v", "c"],
  },
  {
    name: "Crescendo",
    arrangement: ["v", "c", "v", "c", "b", "c", "c"],
  },
  {
    name: "Intro Repeat",
    arrangement: ["v", "v", "c", "v", "c", "c"],
  },
  {
    name: "Verse First",
    arrangement: ["v", "v", "v", "c", "v", "c"],
  },
  {
    name: "Bridge Ending",
    arrangement: ["v", "c", "v", "c", "b", "b"],
  },
  {
    name: "Triple Verse",
    arrangement: ["v", "v", "v", "c", "c"],
  },
  {
    name: "Verse Heavy",
    arrangement: ["v", "v", "v", "c", "v", "b"],
  },
  {
    name: "All Chorus",
    arrangement: ["c", "c", "c", "c"],
  },
  {
    name: "Double Outro",
    arrangement: ["v", "c", "v", "c", "c", "c", "c"],
  },
  {
    name: "Chorus Build",
    arrangement: ["v", "c", "v", "b", "c", "c"],
  },
  {
    name: "Looping",
    arrangement: ["v", "c", "v", "c", "v", "c"],
  },
  {
    name: "Climactic Outro",
    arrangement: ["v", "c", "v", "b", "c", "c", "c"],
  },
  {
    name: "All Bridge",
    arrangement: ["b", "b", "b", "b"],
  },
  {
    name: "Interlude Focus",
    arrangement: ["v", "c", "b", "b", "c"],
  },
  {
    name: "Outro Bridge",
    arrangement: ["v", "c", "v", "b", "b"],
  },
  {
    name: "Verse Intro",
    arrangement: ["v", "v", "c", "b", "c"],
  },
  {
    name: "Chorus First",
    arrangement: ["c", "v", "v", "c", "b", "c"],
  },
  {
    name: "Bridge Finale",
    arrangement: ["v", "c", "v", "c", "b", "b", "b"],
  },
  {
    name: "Bridge Peak",
    arrangement: ["v", "c", "b", "b", "c", "c"],
  },
  {
    name: "Balanced",
    arrangement: ["v", "c", "b", "c", "b", "c"],
  },
  {
    name: "Layered",
    arrangement: ["v", "c", "b", "v", "c", "c"],
  },
  {
    name: "Dynamic",
    arrangement: ["b", "c", "v", "c", "b", "c"],
  },
  {
    name: "Inverse",
    arrangement: ["c", "v", "b", "v", "c"],
  },
  {
    name: "Echo",
    arrangement: ["v", "c", "v", "b", "v", "c"],
  },
  {
    name: "End Focus",
    arrangement: ["v", "c", "b", "c", "b", "c"],
  },
  {
    name: "Sequential",
    arrangement: ["v", "c", "b", "v", "c", "b"],
  },
  {
    name: "Complex",
    arrangement: ["v", "c", "v", "b", "c", "v", "b", "c"],
  },
  {
    name: "Heavy Outro",
    arrangement: ["v", "c", "b", "c", "c", "c"],
  },
  {
    name: "Evolving",
    arrangement: ["v", "c", "v", "b", "v", "c", "b"],
  },
  {
    name: "Drift",
    arrangement: ["v", "v", "c", "b", "v", "c"],
  },
  {
    name: "Offset",
    arrangement: ["v", "b", "c", "v", "b", "c"],
  },
  {
    name: "Stacked",
    arrangement: ["v", "v", "b", "b", "c", "c"],
  },
  {
    name: "Triple Bridge",
    arrangement: ["v", "c", "b", "b", "b", "c"],
  },
  {
    name: "Finale",
    arrangement: ["v", "c", "v", "c", "b", "b", "c"],
  },
  {
    name: "Vibrant",
    arrangement: ["v", "c", "b", "c", "v", "c"],
  },
  {
    name: "Repeater",
    arrangement: ["v", "c", "v", "c", "b", "c", "b", "c"],
  },
];

export default sectionTemplates;
